export const GET_HASHLESS_TICKET_START = 'GET_HASHLESS_TICKET_START';
export const GET_HASHLESS_TICKET_SUCCESS = 'GET_HASHLESS_TICKET_SUCCESS';
export const GET_HASHLESS_TICKET_FAIL = 'GET_HASHLESS_TICKET_FAIL';
export const GET_HASHLESS_TICKET_RESET = 'GET_HASHLESS_TICKET_RESET';
